<template>
  <div>
    <div class="row">
      <div class="col-6">
        <label class="ml-2 mb-1 mt-2">ANREDE *</label>
        <select
          :value="address.prefix"
          @input="update('prefix', $event.target.value)"
          :class="{ 'error-input': validations.some(e => e === 'prefix') }"
          class="select-box mb-1"
        >
          <option value="" disabled selected>Option auswählen</option>
          <option v-for="prefix in config.prefixes" :value="prefix">{{
            prefix
          }}</option>
        </select>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <label class="ml-2 mb-1">VORNAME *</label>
        <input
          :value="address.firstname"
          @input="update('firstname', $event.target.value)"
          :class="{ 'error-input': validations.some(e => e === 'firstname') }"
          type="text"
          class="text-input mb-1"
        />
      </div>

      <div class="col-6">
        <label class="ml-1 mb-1">NACHNAME *</label>
        <input
          :value="address.lastname"
          @input="update('lastname', $event.target.value)"
          :class="{ 'error-input': validations.some(e => e === 'lastname') }"
          type="text"
          class="text-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <label class="ml-1 mb-1">LAND *</label>
        <CountrySelect v-model="country" class="select-box mb-1" />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-3 pr-0">
        <label class="ml-2 mb-1">PLZ *</label>
        <input
          :value="address.post"
          @input="update('post', $event.target.value)"
          type="text"
          :class="{ 'error-input': validations.some(e => e === 'post') }"
          class="text-input mb-1"
        />
        <div
          v-if="autocomplete.type === 'post' && activeAutocomplete === true"
          class="autocomplete-address"
        >
          <a
            href="javascript:void(0)"
            class="futalis-text-green-strong text-center"
            v-if="autocomplete.isFetching"
          >
            <i class="fad fa-spinner-third fa-2x fa-spin mt-1" />
          </a>
          <a
            href="javascript:void(0)"
            v-else
            class="futalis-text-green-strong"
            v-for="info in autocomplete.data"
            @click="select('post', info.zip)"
          >
            {{ info.zip }}
          </a>
        </div>
      </div>

      <div class="col-9">
        <label class="ml-1 mb-1">STADT *</label>
        <input
          :value="address.city"
          @input="update('city', $event.target.value)"
          :class="{ 'error-input': validations.some(e => e === 'city') }"
          type="text"
          class="text-input mb-1"
        />
        <div
          v-if="autocomplete.type === 'city' && activeAutocomplete === true"
          class="autocomplete-address"
        >
          <a
            href="javascript:void(0)"
            class="futalis-text-green-strong text-center"
            v-if="autocomplete.isFetching"
          >
            <i class="fad fa-spinner-third fa-2x fa-spin mt-1" />
          </a>
          <a
            href="javascript:void(0)"
            v-else
            class="futalis-text-green-strong"
            v-for="info in autocomplete.data"
            @click="select('city', info.city)"
          >
            {{ `${info.city} ${info.city_additional}` }}
          </a>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-9 pr-1">
        <label class="ml-2 mb-1">STRASSE *</label>
        <input
          :value="address.street1"
          @input="update('street1', $event.target.value)"
          :class="{ 'error-input': validations.some(e => e === 'street1') }"
          type="text"
          class="text-input mb-1"
        />
        <div
          v-if="autocomplete.type === 'street1' && activeAutocomplete === true"
          class="autocomplete-address"
        >
          <a
            href="javascript:void(0)"
            class="futalis-text-green-strong text-center"
            v-if="autocomplete.isFetching"
          >
            <i class="fad fa-spinner-third fa-2x fa-spin mt-1" />
          </a>
          <a
            href="javascript:void(0)"
            v-else
            class="futalis-text-green-strong"
            v-for="info in autocomplete.data"
            @click="select('street1', info.street)"
          >
            {{ info.street }}
          </a>
        </div>
      </div>

      <div class="col-3 pl-1">
        <label class="mb-1">HAUSNR.*</label>
        <input
          :value="address.street2"
          :disabled="isHouseNumberDisabled"
          @input="update('street2', $event.target.value)"
          :class="{ 'error-input': validations.some(e => e === 'street2') }"
          type="text"
          class="text-input mb-1"
        />
      </div>

      <div class="col-12 mt-2">
        <label class="ml-1 text-uppercase mb-1">ADRESSZUSATZ (OPTIONAL)</label>
        <input
            :value="address.additional_address"
            @input="update('additional_address', $event.target.value)"
            type="text"
            class="text-input mb-1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CountrySelect from '../../common/CountrySelect';
export default {
  name: 'AddressForm',
  props: [
    'address',
    'activeAutocomplete',
    'getAddressSuggestions',
    'autocomplete',
    'selectFromAutoComplete',
    'validations',
    'config'
  ],
  data() {
    return {};
  },
  methods: {
    select(field, value) {
      this.selectFromAutoComplete(field, value);
    },
    update(key, value) {
      let resetFields = {};
      switch (key) {
        case 'country':
          resetFields = { city: '', street1: '', street2: '', post: '' };
          break;
        case 'post':
          resetFields = { street1: '', street2: '' };
          break;
        case 'city':
          resetFields = { };
          break;
        case 'street1':
          resetFields = { street2: '' };
          break;
      }
      this.$emit('input', { ...this.address, ...resetFields, [key]: value });
      if (
        ['city', 'street1', 'post', 'street2'].some(
          element => element === key
        ) &&
        this.address.country === 'DE'
      ) {
        this.getAddressSuggestions(key);
      }
    }
  },
  components: { CountrySelect },
  model: {
    prop: 'address',
    event: 'input'
  },
  computed: {
    country: {
      get() {
        return this.address.country;
      },
      set(value) {
        this.update('country', value);
      }
    },
    isHouseNumberDisabled() {
      if (this.address.country === 'DE') {
        return (
          this.address.post === '' ||
          this.address.street1 === '' ||
          this.address.city === ''
        );
      } else {
        return false;
      }
    }
  },
  watch: {
    address(newAddress, oldAddress) {
      if (oldAddress.country !== 'DE' && newAddress.country === 'DE') {
        this.$emit('input', {
          ...this.address,
          post: '',
          street1: '',
          city: '',
          street2: ''
        });
      }
    }
  },
  mounted() {}
};
</script>

<style scoped>
.select-box {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  color: #495057;
  font-size: 0.8rem;
  background: #fff
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #e6e7d5;
  border-radius: 0.2rem;
  appearance: none;
}
.text-input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.8rem;
  color: #495057;
  background: #fff;
  border: 1px solid #e6e7d5;
}

.autocomplete-address {
  position: absolute;
  width: calc(100% - 1.2em);
  z-index: 9999;
  max-height: 350px;
  overflow-y: auto;
}
.autocomplete-address a {
  display: block;
  background-color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 5px;
  border-bottom: 0.05rem solid #aaa69e;
  line-height: 35px;
}
.autocomplete-address a:hover {
  display: block;
  background-color: #f2f2f2;
}

.error-input {
  border: 1px solid #ff456e !important;
}

.text-input:disabled {
  background-color: #f9fafa;
}
</style>
